import React, { Component } from "react";

import styled from "styled-components";
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import OfferInfoForm from "../../components/forms/OfferInfoForm/OfferInfoForm";
import {
  addOfferHistory,
  deleteOffer,
  getOfferById,
  getOfferHistoryList,
  getOfferTrackersList,
  offerStateInit,
  postOffer,
  setOfferHistoryItem,
  updateOffer,
  updateOfferStatus,
} from "../../store/offers/actions";
import {
  getFilteredBudgets,
  getMediaBuyerDataForAdd,
} from "../../store/mediabuyers/mediabuyerbudget/actions";
import OfferTracker from "./OffersTrackers";
import OfferMediaBuyersBudget from "./OfferMediaBuyersBudget";
import OfferMediaBuyersPlans from "./OfferMediaBuyerPlans";
import OfferHistory from "./OffersHistory";
import { getFilteredPlans } from "../../store/mediabuyers/mediabuyerplans/actions";
import DynamicModalWithInput from "../../components/DynamicModalWithInput/DynamicModalWithInput";
import PreloaderData from "../../components/PreloaderData";
import StatusModal from "./Modals/StatusModal";
import queryString from "query-string";
import SweetAlert from "react-bootstrap-sweetalert";
import ModifiedMetaTags from '../../components/ModifiedMetaTags/index';

class OfferInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "profile",
      not_render: false,
      deleteModalActive: false,
      copyModalActive: false,
      viewStatusOffer: false,
      editData: null,
      infoData: null,
      infoAlert: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const query = queryString.parse(window.location.search);
    if (query.history === "true") {
      this.props.getOfferById(this.props.match.params.offerId);
    }

    if (!this.props.location.state?.was_created) {
      this.props.getOfferById(
        this.props.match.params.offerId,
        this.props.history,
        true
      );
    } else {
      this.props.history.replace({ state: { was_created: false } });
    }

    this.props.getFilteredPlans(
      `offer=${this.props.match.params.offerId}`,
      this.props.plans
    );

    this.props.getOfferTrackersList(
      this.props.offerTrackerData,
      this.props.match.params.offerId
    );

    this.props.getOfferHistoryList(this.props.match.params.offerId);

    this.handleUpdateTab();
  }

  handleUpdateTab = () => {
    const hash = this.props.location.hash.split("#").join("") || "profile";
    this.toggle(hash);
  };

  componentDidUpdate(prevProps, props) {
    const query = queryString.parse(window.location.search);
    const { match } = this.props;

    if (prevProps.match.params.offerId !== match.params.offerId) {
      const query = queryString.parse(window.location.search);
      if (query.history === "true") {
        this.props.getOfferById(this.props.match.params.offerId);
      }

      if (!this.props.location.state?.was_created) {
        this.props.getOfferById(
          this.props.match.params.offerId,
          this.props.history,
          true
        );
      } else {
        this.props.history.replace({ state: { was_created: false } });
      }

      this.props.getFilteredPlans(
        `offer=${this.props.match.params.offerId}`,
        this.props.plans
      );

      this.props.getOfferTrackersList(
        this.props.offerTrackerData,
        this.props.match.params.offerId
      );

      this.props.getOfferHistoryList(this.props.match.params.offerId);

      this.handleUpdateTab();
    }

    if (prevProps.location.hash !== this.props.location.hash) {
      this.handleUpdateTab();

      if (match.params.offerId !== prevProps.match.params.offerId) {
        if (query.history !== "true") {
          this.onExitFromHistoryItem();
        }
      }
    }

    if (prevProps.dataForAddBudget !== this.props.dataForAddBudget) {
      this.props.getMediaBuyerDataForAdd();
    }

    if (!prevProps.history_item && this.props.history_item) {
      this.toggle("profile");
    }
  }

  viewStatusOfferModal = () => {
    this.setState(prevState => ({
      viewStatusOffer: !prevState.viewStatusOffer,
      editData: null,
    }));
  };

  onClickStatus = type => {
    this.setState(prevState => ({
      viewStatusOffer: !prevState.viewStatusOffer,
      editData: type,
    }));
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  formSubmit = (data, is_add_to_history = false) => {
    if (!data?.is_rent) {
      data.applications = [data.applications];
    }

    const offer_id = this.props.history_item?.id || this.props.offer?.id;

    const callback = () => {
      this.props.getOfferHistoryList(this.props.match.params.offerId);
      this.props.getOfferById(
        this.props.match.params.offerId,
        this.props.history,
        true
      );
    };

    if (!is_add_to_history) {
      this.props.updateOffer(
        offer_id,
        data,
        this.props.history_item ? callback : null
      );
    } else {
      this.props.addOfferHistory(data);
    }
  };

  copyOfferProcess = copyName => {
    const data = {};
    const regions = [];

    for (let [key, value] of Object.entries(this.props.offer)) {
      if (value !== null) {
        data[key] = value;
      }
    }

    data.active_costs_of_regions.map(item => {
      let regions_data = {};
      for (let [key, value] of Object.entries(item)) {
        if (value !== null) {
          regions_data[key] = value;
        }
      }
      regions.push(regions_data);
    });

    data.name = copyName;
    data.regions = regions;
    data.contract = data.contract?.id;
    data.applications = [data.app];

    this.props.postOffer({ data, history: this.props.history });
  };

  onDelete = () => {
    const { deleteModalActive } = this.state;
    this.setState({ deleteModalActive: !deleteModalActive });
    const redirectToClient = () => {
      if (this.props.offer?.is_rent) {
        this.props.history.push(
          `/clients/${this.props.offer?.my_client}#rent_offers`
        );
      } else {
        this.props.history.push(
          `/clients/${this.props.offer?.client_id}#offers`
        );
      }
    };
    this.props.deleteOffer(this.props.match.params.offerId, redirectToClient);
  };

  onActiveDeleteModal = () => {
    const { deleteModalActive } = this.state;
    this.setState({ deleteModalActive: !deleteModalActive });
  };

  onCopy = name => {
    const { copyModalActive } = this.state;
    if (copyModalActive) {
      this.copyOfferProcess(name);
    }
    this.setState({ copyModalActive: !copyModalActive });
  };

  onActiveCopyModal = () => {
    const { copyModalActive } = this.state;
    this.setState({ copyModalActive: !copyModalActive });
  };

  componentWillUnmount() {
    this.props.offerStateInit();
  }

  onExitFromHistoryItem = () => {
    this.props.setOfferHistoryItem(null);
    // this.toggle("history");
    if (!!this.props.offer) {
      this.props.history.push(`/offers/${this.props.offer?.id}#history`);
    }
  };

  getOfferStatus = status => {
    switch (status) {
      case 0:
        return {
          title: "archived",
          status: "secondary",
          icon: "archive",
        };
      case 1:
        return {
          title: "active",
          status: "success",
          icon: "check",
        };
      // case 2:
      //   return {
      //     title: "rent",
      //     status: "info",
      //     icon: "check"
      //   };
      case -1:
        return {
          title: "not active",
          status: "danger",
          icon: "block",
        };
    }
  };

  onClickRent = (appName, currentStatus) => {
    const data = {
      appName,
      title: "Change rent status",
      rentStatus: currentStatus ? "yes" : "no",
      onConfirm: () => {
        this.props.updateOffer(this.props.offer?.id, {
          is_rent: !currentStatus,
        });
        this.setState({ infoAlert: false });
      },
    };
    this.setState({
      infoData: data,
      infoAlert: !this.state.infoAlert,
    });
  };

  render() {
    const offer = this.props.history_item || this.props.offer;
    const is_rent = +this.props.location.state?.is_rent;
    const { infoData, infoAlert } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          {infoAlert && (
            <SweetAlert
              showCancel
              confirmBtnText="Change"
              cancelBtnText="Cancel"
              confirmBtnBsStyle="success"
              title={infoData?.title || "Default name"}
              onCancel={() => this.setState({ infoAlert: false })}
              onConfirm={infoData.onConfirm}
            >
              {infoData?.rentStatus ? (
                infoData.rentStatus == "yes" ? (
                  <p>Are you sure want to change offer rent status?</p>
                ) : (
                  <p>Are you sure want to change offer rent status?</p>
                )
              ) : (
                ""
              )}
            </SweetAlert>
          )}

          {this.state.viewStatusOffer && (
            <StatusModal
              toggle={this.viewStatusOfferModal}
              offerId={this.props.match.params.offerId}
              isOpen={this.state.viewStatusOffer}
              currentStatus={this.props.offer?.status}
              updateOfferStatus={this.props.updateOfferStatus}
              historyData={this.props.historyData}
              permissions={this.props.permissions}
            />
          )}
          <ModifiedMetaTags title={`${this.props.offer?.name || 'Offer'} | Mobihunter`} />

          <Container fluid>
            <Breadcrumbs
              title="Client"
              customBreadcrumbItem={
                <>
                  {this.props.offer?.name}{" "}
                  <small className="text-muted">{`(${this.props.offer?.date_from} - ${this.props.offer?.date_to})`}</small>
                </>
              }
              breadcrumbItem={`${this.props.offer?.name}`}
              link="/clients"
            />
            <Row>
              <Col sm={12}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center">
                      <Nav
                        tabs
                        className="nav-tabs-custom"
                        style={{
                          width: "50%",
                          borderBottom: "0",
                        }}
                      >
                        <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            // to={{ hash: "" }}
                            to={location => ({ ...location, hash: "" })}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "profile",
                            })}
                            onClick={() => {
                              this.toggle("profile");
                            }}
                          >
                            Profile
                          </Link>
                        </NavItem>
                        <NavItem>
                          <Link
                            style={{ cursor: "pointer" }}
                            to={location => ({ ...location, hash: "trackers" })}
                            className={classnames("nav-link", {
                              active: this.state.activeTab === "trackers",
                            })}
                            onClick={() => {
                              this.toggle("trackers");
                            }}
                          >
                            Trackers
                          </Link>
                        </NavItem>
                        {!this.props.history_item && (
                          <NavItem>
                            <Link
                              style={{ cursor: "pointer" }}
                              // to={{ hash: "history" }}
                              to={location => ({
                                ...location,
                                hash: "history",
                              })}
                              className={classnames("nav-link", {
                                active: this.state.activeTab === "history",
                              })}
                              onClick={() => {
                                this.toggle("history");
                              }}
                            >
                              History
                            </Link>
                          </NavItem>
                        )}
                      </Nav>
                      <div className="d-flex">
                        {!this.props.history_item && (
                          <div>
                            {this.props.offer && (
                              <>
                                <button
                                  type="button"
                                  // onClick={() =>
                                  //   this.onClickRent(
                                  //     this.props.offer?.name,
                                  //     this.props.offer?.is_rent
                                  //   )
                                  // }
                                  className={`btn btn-${
                                    this.props.offer?.is_rent
                                      ? "info"
                                      : "secondary"
                                  } waves-effect btn-label waves-light fade-in-custom-animate me-2`}
                                >
                                  <i
                                    className={`bx bx-${
                                      this.props.offer?.is_rent
                                        ? "calendar-check"
                                        : "bx bx-calendar-x"
                                    } label-icon`}
                                  />
                                  Offer{" "}
                                  {this.props.offer?.is_rent
                                    ? " is rent"
                                    : " isn't rent"}
                                </button>
                                <button
                                  type="button"
                                  onClick={() =>
                                    this.props.permissions[
                                      "change_appoffermodel"
                                    ] && this.onClickStatus("status")
                                  }
                                  className={`btn btn-${
                                    this.getOfferStatus(
                                      this.props.offer?.status
                                    )?.status
                                  } waves-effect btn-label waves-light fade-in-custom-animate`}
                                >
                                  <i
                                    className={`bx bx-${
                                      this.getOfferStatus(
                                        this.props.offer?.status
                                      )?.icon
                                    } label-icon`}
                                  />
                                  Offer is{" "}
                                  {
                                    this.getOfferStatus(
                                      this.props.offer?.status
                                    )?.title
                                  }
                                </button>
                              </>
                            )}
                          </div>
                        )}
                        <div>
                          {!this.props.history_item &&
                            (this.props.permissions["add_appoffermodel"] ||
                              this.props.permissions[
                                "delete_appoffermodel"
                              ]) && (
                              <UncontrolledDropdown>
                                <DropdownToggle className="card-drop" tag="a">
                                  <ActionsBtn type="button" className="ms-2">
                                    Actions
                                  </ActionsBtn>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                  {this.props.permissions[
                                    "add_appoffermodel"
                                  ] && (
                                    <DropdownItem
                                      onClick={() => this.onActiveCopyModal()}
                                      className="align-middle center align-content-center"
                                    >
                                      <i className="bx bx-copy-alt font-size-16 text-primary me-1 align-middle" />{" "}
                                      Copy offer
                                    </DropdownItem>
                                  )}
                                  {this.props.permissions[
                                    "delete_appoffermodel"
                                  ] && (
                                    <DropdownItem
                                      onClick={() => this.onActiveDeleteModal()}
                                      className="align-middle center align-content-center"
                                    >
                                      <i className="mdi mdi-trash-can font-size-16 text-danger me-1 align-middle" />{" "}
                                      Delete offer
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            )}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>

          <DynamicModalWithInput
            isOpen={this.state.copyModalActive}
            toggle={this.onActiveCopyModal}
            action={this.onCopy}
            header={`Copy offer ${this.props.offer?.name}`}
            alertColor="primary"
            alertText="When copying an offer, a copy is created identical to the one you selected."
            buttonColor="primary"
            buttonText="Copy"
            what="copy"
            text="Enter a new name to create a copy of selected offer"
          />

          <DynamicModalWithInput
            isOpen={this.state.deleteModalActive}
            toggle={this.onActiveDeleteModal}
            action={this.onDelete}
            header={this.props.offer?.name}
            what="delete"
            alertColor="danger"
            alertText="Deleting a offer permanently removes the offer content. The
              profile, trackers, media buyer budgets, media buyer plans and
              offer history."
          />
          {this.props.loader_offer ? (
            <PreloaderData />
          ) : (
            <TabContent
              activeTab={this.state.activeTab}
              className="p-3 text-muted"
            >
              <TabPane tabId="profile">
                {!!this.props.history_item && (
                  <ExitButton
                    className="mb-3 d-flex align-items-center"
                    style={{ marginTop: -20 }}
                    onClick={this.onExitFromHistoryItem}
                  >
                    <div className="me-2">
                      <i className="mdi mdi-arrow-left font-size-22" />
                    </div>
                    <span className="">{`${
                      this.props.history_item.change_description ||
                      "No description"
                    } (${this.props.history_item.date_from} - ${
                      this.props.history_item.date_to
                    })`}</span>
                  </ExitButton>
                )}
                {this.props.offer && (
                  <OfferInfoForm
                    key={this.props.history_item?.id || this.props.offer?.id}
                    // key={this.props.match.params.offerId}
                    onSubmit={this.formSubmit}
                    client_id={
                      this.props.offer?.is_rent
                        ? this.props.offer?.my_client
                        : offer?.client_id
                    }
                    offer={this.props.history_item || this.props.offer}
                    is_rent={is_rent}
                    // isHistory={!!this.props.history_item}
                    readOnly={!this.props.permissions["change_appoffermodel"]}
                  />
                )}
              </TabPane>
              <TabPane tabId="trackers">
                {this.props.offer && (
                  <OfferTracker data={this.props.offerTrackerData} />
                )}
              </TabPane>
              <TabPane tabId="media-buyer-budgets">
                {this.state.activeTab === "media-buyer-budgets" && (
                  <OfferMediaBuyersBudget
                    history={this.props.history}
                    offer={this.props.offer}
                  />
                )}
              </TabPane>
              <TabPane tabId="media-buyer-plans">
                {this.state.activeTab === "media-buyer-plans" && (
                  <OfferMediaBuyersPlans
                    history={this.props.history}
                    offer={this.props.offer}
                  />
                )}
              </TabPane>
              <TabPane tabId="history">
                {this.props.offer && (
                  <OfferHistory
                    toggle={this.toggle}
                    // data={this.props.historyData}
                    // current={this.props.history_item}
                  />
                )}
              </TabPane>
            </TabContent>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const ExitButton = styled.h6`
  transition: 0.2s;
  cursor: pointer;

  div {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
  }

  &:hover {
    //background-color: rgba(204, 204, 204, 0.42);
    color: #556ee6;
  }
`;

const ActionsBtn = styled.div`
  color: hsl(0, 0%, 70%);
  user-select: none;
  padding: 7.5px 12px;
  border: 1.5px solid hsl(0, 0%, 70%);
  border-radius: 5px;
  transition-duration: 0.5s;

  &:hover {
    transition-duration: 0.5s;
    color: hsl(0, 0%, 55%);
    border: 1.5px solid hsl(0, 0%, 55%);
  }
`;

OfferInfo.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      offerId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  getFilteredBudgets: PropTypes.func.isRequired,
  getFilteredPlans: PropTypes.func.isRequired,
  getOfferById: PropTypes.func.isRequired,
  getOfferTrackersList: PropTypes.func.isRequired,
  getOfferHistoryList: PropTypes.func.isRequired,
  offer: PropTypes.any,
  offerTrackerData: PropTypes.any,
  historyData: PropTypes.any,
  location: PropTypes.object.isRequired,
  updateOffer: PropTypes.func.isRequired,
  deleteOffer: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  dataForAddBudget: PropTypes.any,
  budgets: PropTypes.any,
  plans: PropTypes.any,
  offerStateInit: PropTypes.func,
  postOffer: PropTypes.func.isRequired,
  loader_offer: PropTypes.bool.isRequired,
  addOfferHistory: PropTypes.func,
  history_item: PropTypes.any,
  permissions: PropTypes.any,
  setOfferHistoryItem: PropTypes.func,
  updateOfferStatus: PropTypes.func,
};

const mapStateToProps = state => ({
  budgets: state.MediaBuyerBudgets.data,
  plans: state.MediaBuyerPlans.data,
  loader_offer: state.Offers.loader_offer,
  offer: state.Offers.offer,
  offerTrackerData: state.Offers.dataTrackers,
  historyData: state.Offers.historyData,
  history_item: state.Offers.history_item,
  permissions: state.User.permissions,
});

export default withRouter(
  connect(mapStateToProps, {
    postOffer,
    getOfferById,
    updateOffer,
    deleteOffer,
    getOfferTrackersList,
    getOfferHistoryList,
    getMediaBuyerDataForAdd,
    getFilteredBudgets,
    getFilteredPlans,
    offerStateInit,
    addOfferHistory,
    setOfferHistoryItem,
    updateOfferStatus,
  })(OfferInfo)
);
